export default [
	{ value: 'SUMMIT', label: 'SUMMIT' },
	{ value: 'External', label: 'External' },
	{ value: 'HSC', label: 'PEAK' },
	{ value: 'DB', label: 'DB' },
];

/**
 * The same sources for filtering, where the value lands in the URL rather than
 * on a property record. Peak is 'PEAK' here so no link shows HSC; filter.js maps
 * it back to the 'HSC' the SOURCE column actually stores. Writing a property
 * still uses the list above — a record must keep the stored value.
 */
export const filterSourceTypes = [
	{ value: 'SUMMIT', label: 'SUMMIT' },
	{ value: 'External', label: 'External' },
	{ value: 'PEAK', label: 'PEAK' },
	{ value: 'DB', label: 'DB' },
];